import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получить виджет топ гейнеров
export const getTopGainersWidget = async () => {
  const url = `${backendUrl}/api/screener/widgets/top-gainers/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Ошибка при получении виджета топ гейнеров: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения виджета топ гейнеров:', error);
    throw error;
  }
};
